<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'ProductList' }">Products</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <!-- <el-button @click="testImage()">test</el-button> -->

    <el-tabs type="card" v-model="active_tab" @tab-click="handleTabClick">
      <el-tab-pane label="Details" name="details">

        <el-form 
          ref="product" 
          :model="product"
          :rules="rules.product"
          v-loading="loading"
          :label-position="label_position">

          <el-form-item>
            <el-switch
              :active-value="1"
              :inactive-value="0"
              active-text="Enabled"
              inactive-text="Disabled"
              v-model="product.enabled">
            </el-switch>
          </el-form-item>

           <el-form-item>
             <el-switch
              :active-value="1"
              :inactive-value="0"
              active-text="Can Be Purchased"
              inactive-text="Can Not Be Purchased"
              v-model="product.can_be_purchased">
            </el-switch>
              <!-- <el-checkbox v-model="product.can_be_purchased">Option</el-checkbox> -->    
          </el-form-item>

          <el-form-item label="Name" prop="name">
            <el-input v-model="product.name"></el-input>
          </el-form-item>

          <el-form-item label="SKU" prop="sku">
              <el-input v-model="product.sku"></el-input>
          </el-form-item>

          <el-form-item>
            <el-switch
              :active-value="1"
              :inactive-value="0"
              active-text="Editable"
              inactive-text="Not Editable"
              v-model="product.is_editable">
            </el-switch>
          </el-form-item>

          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="Product Type" prop="product_type_id">
                <el-select
                  v-model="product.product_type_id" 
                  placeholder="Product type"
                  value-key="id">
                  <el-option
                    v-for="item in product_types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>                
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Tax Class" prop="tax_class_id">
                <el-select  
                  :span="12"
                  v-model="product.tax_class_id" 
                  placeholder="Tax class"
                  value-key="id">
                  <el-option
                    v-for="item in tax_classes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>                
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="Specification">
            <el-input type="textarea" :rows="3" :autosize="false" v-model="product.specification"></el-input>
          </el-form-item>
            
          <el-form-item label="Short Description" prop="short_description">
            <el-input type="textarea" :rows="3" :autosize="false" v-model="product.short_description"></el-input>
          </el-form-item>

          <el-form-item label="Description">
            <el-input type="textarea" :rows="7" :autosize="false" v-model="product.description"></el-input>
          </el-form-item>

            <el-form-item label="Recommended Margins">
                <div v-if="product.min_recommended_margin == 0 && product.max_recommended_margin == 0">   
                <div style="margin-top: 15px; width:500px;" >
                  <el-input placeholder="Please input" 
                      v-model="quote.markup"
                      :min="0"
                      :max="100"
                      :step="5"
                      :show-stops="false">
                    <template slot="append">%</template>
                  </el-input>
                </div>
                </div>

                <div v-else>
                  <el-input
                    v-model="quote.markup"
                    :min="product.min_recommended_margin"
                    :max="product.max_recommended_margin"
                    :step="5"
                    :show-stops="false">
                  </el-input>
                </div>  
            </el-form-item> 

          <el-form-item label="Track Inventory">
            <el-switch
              :inactive-value="0"
              :active-value="1"
              v-model="product.track_inventory">
            </el-switch>
          </el-form-item>

          <el-row>
            <el-col :span="11">
              <el-form-item label="Stock Level">
                <el-input v-model="product.stock_level" :disabled="product.track_inventory == 0"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="2">
              <el-form-item label="Alow Backorder" :span="12">
                <el-switch
                  :disabled="product.track_inventory == 0"
                  :inactive-value="0"
                  :active-value="1"
                  v-model="product.allow_backorder">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="Pricing Method">
            <el-switch
              :active-value="1"
              :inactive-value="0"
              active-text="Tiered"
              inactive-text="Ranged"
              v-model="product.is_tiered">
            </el-switch>
            
            <span class="form-hint"><i class="el-icon-warning"></i> If you change this value then make sure your pricing tiers reflect the correct minimum and maximum quantity</span> 
          </el-form-item>

          <el-form-item label="Minimum Recommended Margin" prop="min_recommended_margin">
                <el-input type="textarea" :rows="1" :autosize="false" v-model="product.min_recommended_margin"></el-input>
            </el-form-item>

            <el-form-item label="Maximum Recommended Margin" prop="max_recommended_margin">
                <el-input type="textarea" :rows="1" :autosize="false" v-model="product.max_recommended_margin"></el-input>
            </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="updateProduct('product')">Update</el-button>
          </el-form-item>
        </el-form>

      </el-tab-pane>
    
      <el-tab-pane v-if="product.can_be_purchased" :disabled="!product.can_be_purchased == true" label="Pricing Tiers" name="pricing_tiers">
     
        <div class="actions-bar">
          <el-row>
            <el-button v-if="!form_tier_show" type="default" @click="toggleFormTier('Add'), clearTier()">Add Tier</el-button>
            <el-button v-if="form_tier_show" type="default" @click="toggleFormTier('')">Cancel</el-button>
            <el-button v-if="!form_tier_show" type="default" @click="batch_markup_dialog = true">Batch Markup Change</el-button>

            <download-excel
              v-if="!form_tier_show"
              class="el-button el-button--default"
              :data="product.product_shipping_matrix"
              :fields="tier_headings"
              name="Tiers.xls">
                Download Tiers
            </download-excel>

            <el-dropdown trigger="click" :hide-on-click="true" :hide-timeout="1" v-if="!form_tier_show">
              <el-tooltip class="item" effect="light" content="Show or hide columns" placement="top">
                <el-button>
                  Columns <i class="el-icon-caret-bottom"></i>
                </el-button>
              </el-tooltip>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(column, index) in pricing_tiers_columns" :key="index">
                  <el-checkbox v-model="pricing_tiers_columns[index]">{{index | prettyIndexName}}</el-checkbox>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-row>
        </div>

        <el-form
          v-if="form_tier_show"
          ref="tier" 
          :model="tier"
          :rules="rules.tier"
          :label-position="label_position">

          <el-form-item label="Country" prop="country">
            <el-select 
              v-model="tier.country" 
              placeholder="Select country"
              :filterable="true"
              :clearable="false">
              <el-option v-for="country in country_list" :key="country.code" :label="country.name" :value="country.name"></el-option>
            </el-select>
          </el-form-item>

          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="State" prop="state">
                <el-input v-model="tier.state"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="City" prop="city">
                <el-input v-model="tier.city"></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="8">
              <el-form-item label="Zip" prop="zip">
                <el-input v-model="tier.zip"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="Minimum Quantity" prop="min_qty">
                <el-input v-model="tier.min_qty"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Max Quantity" prop="max_qty">
                <el-input v-model="tier.max_qty" :disabled="product.is_tiered === 1"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="Unit Cost Price" prop="product_cost_price">
                <el-input v-model="tier.product_cost_price">
                  <template slot="prepend">{{config.currency}}</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Unit Retail Price" prop="product_retail_price">
                <el-input v-model="tier.product_retail_price">
                  <template slot="prepend">{{config.currency}}</template>                  
                  <el-button slot="append" icon="el-icon-question" @click="markup_dialog = true"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="Pack Cost Price" prop="pack_cost_price">
                <el-input v-model="tier.pack_cost_price">
                  <template slot="prepend">{{config.currency}}</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Pack Retail Price" prop="pack_retail_price">
                <el-input v-model="tier.pack_retail_price">
                  <template slot="prepend">{{config.currency}}</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="Pack Maximum Quantity" prop="pack_max_quantity">
                <el-input v-model="tier.pack_max_quantity"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Pack Weight" prop="pack_weight">
                <el-input v-model="tier.pack_weight"></el-input>
              </el-form-item>
            </el-col>  
          </el-row>

          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="Pack Discount" prop="pack_discount">
                <el-input v-model="tier.pack_discount"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Turnaround Time" prop="product_turnaround_time">
                <el-input v-model="tier.product_turnaround_time"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="Supplier" prop="supplier_id">
                <el-select 
                  v-model="tier.supplier_id" 
                  placeholder="Select supplier"
                  :filterable="true"
                  :clearable="false"
                  value-key="supplier_id">
                  <el-option v-for="supplier in suppliers" :key="supplier.id" :label="supplier.name" :value="supplier.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="Print Type" prop="print_type_id">
                <el-select 
                  v-model="tier.print_type_id" 
                  placeholder="Select print type"
                  :filterable="true"
                  :clearable="false"
                  value-key="print_type_id">
                  <el-option v-for="print_type in print_types" :key="print_type.id" :label="print_type.name" :value="print_type.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="Shipping Tax Class" prop="tax_class_id">
                <el-select 
                  v-model="tier.tax_class_id" 
                  placeholder="Select tax class"
                  :filterable="true"
                  :clearable="false"
                  value-key="tax_class_id">
                  <el-option v-for="shipping_tax_class in shipping_tax_classes" :key="shipping_tax_class.id" :label="shipping_tax_class.name" :value="shipping_tax_class.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-button v-if="form_tier_mode == 'Add'" type="primary" @click="addPricingTier('tier')">{{form_tier_mode}} Pricing Tier</el-button>
          <el-button v-if="form_tier_mode == 'Update'" type="primary" @click="updatePricingTier('tier')">{{form_tier_mode}} Pricing Tier</el-button>
        </el-form>

        <el-table
          v-if="!form_tier_show"
          v-loading.body="loading"
          :data="product.product_shipping_matrix"
          :default-sort = "{prop: 'min_qty', order: 'ascending'}"
          border
          resizable="true"
          style="width: 100%">
          
          <el-table-column
            v-if="pricing_tiers_columns.id"
            prop="id"
            label="ID"
            width="115%">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.country"
            prop="country"
            label="Country">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.state"
            prop="state"
            label="State">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.zip"
            prop="zip"
            label="Zip">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.city"
            prop="city"
            label="City">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.min_qty"
            prop="min_qty"
            label="Minimum Quantity"
            sortable>
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.max_qty"
            prop="max_qty"
            label="Maximum Quantity"
            sortable>
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.product_turnaround_time"
            prop="product_turnaround_time"
            label="Turnaround Time">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.product_cost_price"
            prop="product_cost_price"
            label="Cost Price">
            <template slot-scope="scope">
              {{scope.row.product_cost_price | toCurrency}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.product_retail_price"
            prop="product_retail_price"
            label="Retail Price">
            <template slot-scope="scope">
              {{scope.row.product_retail_price | toCurrency}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.pack_cost_price"
            prop="pack_cost_price"
            label="Pack Cost Price">
            <template slot-scope="scope">
              {{scope.row.pack_cost_price | toCurrency}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.pack_retail_price"
            prop="pack_retail_price"
            label="Pack Retail Price">
            <template slot-scope="scope">
              {{scope.row.pack_retail_price | toCurrency}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.pack_discount"
            prop="pack_discount"
            label="Pack Discount">
            <template slot-scope="scope">
              {{scope.row.pack_discount | toCurrency}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.pack_max_quantity"
            prop="pack_max_quantity"
            label="Pack Maximum Quantity">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.pack_weight"
            prop="pack_weight"
            label="Pack Weight">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.supplier_name"
            prop="supplier.name"
            label="Suppler">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.print_type_name"
            prop="print_type.name"
            label="Print Type">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.tax_class_name"
            prop="tax_class.name"
            label="Shipping Tax Class">
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.created_at"
            align="center"
            width="115%"
            prop="created_at"
            label="Created Date">
            <template slot-scope="scope">
              {{scope.row.created_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            v-if="pricing_tiers_columns.updated_at"
            align="center"
            width="115%"
            prop="updated_at"
            label="Updated Date">
            <template slot-scope="scope">
              {{scope.row.updated_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            label="Actions"
            align="center"
            width="115%">
            <template slot-scope="scope">
              <el-button-group>
                <el-button 
                  icon="el-icon-edit"
                  type="default" 
                  size="small"
                  @click="getPricingTier(scope.row.id, scope.row.supplier_id)">
                </el-button>
                <el-button 
                  icon="el-icon-delete"
                  type="default" 
                  size="small"
                  @click="deletePricingTier(scope.row.id)">
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

      </el-tab-pane>

      <el-tab-pane label="Images" name="images">

        <div class="actions-bar">
          <el-row>
            <el-button v-if="!form_image_show" type="default" @click="toggleFormImage('Add')">Add Image</el-button>
            <el-button v-if="form_image_show" type="default" @click="toggleFormImage('')">Cancel</el-button>
          </el-row>
        </div>
          
        <el-form
          v-if="form_image_show"
          ref="product_image" 
          :model="product_image"
          :rules="rules.product_image"
          :label-position="label_position">

          <el-form-item label="Name" prop="name">
            <el-input v-model="product_image.name"></el-input>
          </el-form-item>

          <el-form-item label="Description" prop="description">
            <el-input type="textarea" v-model="product_image.description"></el-input>
          </el-form-item>

          <el-form-item label="Sort Order" prop="sort_order">
            <el-input-number :min="0"  v-model="product_image.sort_order"></el-input-number>
          </el-form-item>

          <el-form-item label="">
            <el-upload
              class="upload"
              ref="upload"
              :action="imageUploadEndpoint"
            
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :multiple="false"
              :limit="1"
              :auto-upload="false"
              :data="product_image"
              :on-success="uploadSuccess"
              list-type="picture">

              <!-- <el-button size="medium" type="default">Select Image</el-button>
              <el-button type="primary" @click="submitUpload">{{form_image_mode}} Image</el-button> -->

              <el-button slot="trigger" type="primary">Select File</el-button>
              <el-button style="margin-left: 10px;" type="success" @click="submitUpload">Upload To Server</el-button>


              <div slot="tip" class="el-upload__tip">jpg/png files with a size less than 2mb</div>
            </el-upload>     
          </el-form-item>		

          

          <div class="image-preview" v-if="imageData.length > 0">
            <img class="preview" :src="imageData">
          </div>
        </el-form>

        <el-table
          v-if="!form_image_show"
          v-loading="loading"
          :data="product.product_images"
          border
          resizable="true"
          style="width: 100%">

          <el-table-column
            align="center"
            width="115%">
            <template slot-scope="scope">
              <img :src="scope.row.path" class="template-thumb"/>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="Name">
          </el-table-column>

          <el-table-column
            prop="description"
            label="Description">
          </el-table-column>

          <el-table-column
            prop="sort_order"
            label="Sort Order">
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            prop="created_at"
            label="Created Date">
            <template slot-scope="scope">
              {{scope.row.created_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            prop="updated_at"
            label="Updated Date">
            <template slot-scope="scope">
              {{scope.row.updated_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            label="Actions"
            align="center"
            width="115%">
            <template slot-scope="scope">
              <el-button-group>
                <el-button 
                  icon="el-icon-edit"
                  type="default" 
                  size="small">
                </el-button>
                <el-button 
                  icon="el-icon-delete"
                  type="default" 
                  size="small"
                  @click="deleteImage(scope.row.id)">
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

      </el-tab-pane>

      <el-tab-pane label="Categories" name="categories">

        <el-card 
          hover="never"
          :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="16">
                <el-input
                :clearable="true"
                placeholder="Filter Categories"
                prefix-icon="el-icon-search"
                v-model="filter_categories"></el-input>
              </el-col>
              <el-col :span="6" :offset="2" class="text-right">
                <el-button @click="assignProductCategories()">Assign Categories</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="scroll-pane">
            <el-checkbox-group v-model="selected_categories">
              <el-checkbox v-for="item in filteredCategories" :label="item.id" :key="item.id" class="checkbox-list">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>

      </el-tab-pane>

      <el-tab-pane label="Corporations" name="corporations">

        <el-card 
          hover="never"
          :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="16">
                <el-input
                :clearable="true"
                placeholder="Filter Corporations"
                prefix-icon="el-icon-search"
                v-model="filter_corporations"></el-input>
              </el-col>
              <el-col :span="6" :offset="2" class="text-right">
                <el-button @click="assignCorporations()">Assign Corporations</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="scroll-pane">
            <el-checkbox-group v-model="selected_corporations">
              <el-checkbox v-for="item in filteredCorporations" :label="item.id" :key="item.id" class="checkbox-list">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>

      </el-tab-pane>

      <el-tab-pane label="Tags" name="tags">

        <el-card 
          hover="never"
          :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="16">
                <el-input
                :clearable="true"
                placeholder="Filter Tags"
                prefix-icon="el-icon-search"
                v-model="filter_tags"></el-input>
              </el-col>
              <el-col :span="6" :offset="2" class="text-right">
                <el-button @click="assignTags()">Assign Tags</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="scroll-pane">
            <el-checkbox-group v-model="selected_tags">
              <el-checkbox v-for="item in filteredTags" :label="item.id" :key="item.id" class="checkbox-list">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>

      </el-tab-pane>

      <el-tab-pane label="Related Products" name="related-products">

        <el-card 
      
          hover="never"
          :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="16">
                <el-input
                :clearable="true"
                placeholder="Filter Products"
                prefix-icon="el-icon-search"
                v-model="filter_products"></el-input>
              </el-col>
              <el-col :span="6" :offset="2" class="text-right">
                <el-button @click="assignProductRelatedProducts()">Assign Products</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="scroll-pane">
            <el-checkbox-group v-model="selected_products">
              <el-checkbox v-for="item in filteredProducts" :label="item.id" :key="item.id" class="checkbox-list">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>

      </el-tab-pane>

      <el-tab-pane label="Files" name="files">
        <div class="actions-bar">
          <el-row>
            <el-button v-if="!form_file_show" type="default" @click="toggleFormFile('Add'), clearFile()">Add File</el-button>
            <el-button v-if="form_file_show" type="default" @click="toggleFormFile('')">Cancel</el-button>
          </el-row> 
        </div>

        <el-form
          v-if="form_file_show"
          ref="file" 
          :model="file"
          :label-position="label_position">

          <el-form-item label="Description" prop="description">
            <el-input type="textarea" v-model="file.description"></el-input>
          </el-form-item>

          <!-- <el-form-item label="Name" prop="name">
            <el-input v-model="file.name"></el-input>
          </el-form-item> -->

          <el-form-item label="Available" prop="available">
            <el-switch
              v-model="file.available"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>

          <el-form-item label="File">
            <div style="margin-bottom:10px;" v-if="upload_file === null">No file selected</div>
            <div v-else> {{ upload_file.name }}</div>
            <input v-if="upload_file == null" ref="imageUpload" type="file" name="imageUpload" id="imageUpload" @change="onFileChange()" >
            <br>
            <el-button v-if="upload_file != null" size="small" type="primary">Upload Image</el-button>
            <el-button v-if="upload_file != null" size="small" type="default">Clear Selection</el-button>       
          </el-form-item>	

          <el-button v-if="form_file_mode == 'Add'" type="primary" @click="addFile('file')">{{form_file_mode}} File</el-button>
          <el-button v-if="form_file_mode == 'Update'" type="primary" @click="updateFile('file')">{{form_file_mode}} File</el-button>
        
        </el-form>

        <el-table
          v-if="!form_file_show"
          v-loading="loading"
          :data="files"
          border
          resizable="true"
          style="width: 100%">

          <el-table-column
            align="center"
            width="115%">
            <template slot-scope="scope">
              <img :src="scope.row.path" class="template-thumb"/>
            </template>
          </el-table-column>

          <el-table-column
            prop="description"
            label="Description">
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            prop="created_at"
            label="Created Date">
            <template slot-scope="scope">
              {{scope.row.created_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            prop="updated_at"
            label="Updated Date">
            <template slot-scope="scope">
              {{scope.row.updated_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            label="Actions"
            align="center"
            width="115%">
            <template slot-scope="scope">
              <el-button-group>
                <el-button 
                  icon="el-icon-edit"
                  type="default" 
                  size="small"
                  @click="getFile(scope.row.id)">
                </el-button>
                <el-button 
                  icon="el-icon-delete"
                  type="default" 
                  size="small"
                  @click="deleteFile(scope.row.id)">
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

      </el-tab-pane>

      <el-tab-pane label="Options" name="options">
        <div class="actions-bar">
          <el-row>
            <el-button v-if="!form_option_show" type="default" @click="toggleFormOption('Add'), clearOption()">Add Option</el-button>
            <el-button v-if="form_option_show" type="default" @click="toggleFormOption('')">Cancel</el-button>
          </el-row>
        </div>

        <el-form
          v-if="form_option_show"
          ref="option" 
          :model="option"
          :rules="rules.option"
          :label-position="label_position">

          <el-form-item label="Name" prop="name">
            <el-input v-model="option.name"></el-input>
          </el-form-item>

          <el-form-item label="Sort Order" prop="sort_order">
            <el-input-number :min="0" v-model="option.sort_order"></el-input-number>
          </el-form-item>

          <el-button v-if="form_option_mode == 'Add'" type="primary" @click="addOption('option')">{{form_option_mode}} Option</el-button>
          <el-button v-if="form_option_mode == 'Update'" type="primary" @click="updateOption('option')">{{form_option_mode}} Option</el-button>
        </el-form>

        <el-table
          v-if="!form_option_show"
          v-loading.body="loading"
          :data="options"
          border
          style="width: 100%">
          
          <el-table-column
            width="115%"
            prop="id"
            label="ID">
          </el-table-column>

          <el-table-column
            prop="name"
            label="Name">
          </el-table-column>

          <el-table-column
            prop="sort_order"
            label="Sort Order">
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            prop="created_at"
            label="Created Date">
            <template slot-scope="scope">
              {{scope.row.created_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            prop="updated_at"
            label="Updated Date">
            <template slot-scope="scope">
              {{scope.row.updated_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            label="Actions">
            <template slot-scope="scope">
              <el-button-group>
                <el-button 
                  icon="el-icon-edit"
                  type="default" 
                  size="small"
                  @click="getOption(scope.row.id)">
                </el-button>
                <el-button 
                  icon="el-icon-delete"
                  type="default" 
                  size="small"
                  @click="deleteOption(scope.row.id)">
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

      </el-tab-pane>

      <el-tab-pane label="Corporation Discounts" name="corporation_discounts">
     
        <div class="actions-bar">
          <el-row>
            <el-button v-if="!form_corporation_discount_show" type="default" @click="toggleFormCorporationDiscount('Add')">Add Discount</el-button>
            <el-button v-if="form_corporation_discount_show" type="default" @click="toggleFormCorporationDiscount('')">Cancel</el-button>
          </el-row>
        </div>

        <el-form
          v-if="form_corporation_discount_show"
          ref="corporation_discount" 
          :model="corporation_discount"
          :rules="rules.corporation_discount"
          :label-position="label_position">

          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="Corporation:" prop="corporation_id">
                <el-select 
                  v-model="corporation_discount.corporation_id" 
                  placeholder="Select Corporation"
                  :filterable="true"
                  :clearable="false"
                  value-key="corporation_id">
                  <el-option v-for="corporation in corporations" :key="corporation.id" :label="corporation.name" :value="corporation.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="Discount Percentage:" prop="discount">
                <el-input-number :min="0" v-model="corporation_discount.discount"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
 
          <el-button v-if="form_corporation_discount_mode == 'Add'" type="primary" @click="addCorporationDiscount('corporation_discount')">{{form_corporation_discount_mode}} Discount</el-button>
          <el-button v-if="form_corporation_discount_mode == 'Update'" type="primary" @click="updateCorporationDiscount('corporation_discount')">{{form_corporation_discount_mode}} Discount</el-button>
        </el-form>

        <el-table
          v-if="!form_corporation_discount_show"
          v-loading.body="loading"
          :data="corporation_discounts"
          border
          resizable="true"
          style="width: 100%">
          
          <el-table-column
            prop="id"
            label="ID"
            width="115%">
          </el-table-column>

          <el-table-column
            prop="corporation.name"
            label="Corporation Name">
          </el-table-column>

          <el-table-column
            prop="discount"
            label="Discount">
            <template slot-scope="scope">
              {{scope.row.discount}}%
            </template>    
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            prop="created_at"
            label="Created Date">
            <template slot-scope="scope">
              {{scope.row.created_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            align="center"
            width="115%"
            prop="updated_at"
            label="Updated Date">
            <template slot-scope="scope">
              {{scope.row.updated_at | moment(config.date_format_compact)}}
            </template>          
          </el-table-column>

          <el-table-column
            label="Actions"
            align="center"
            width="115%">
            <template slot-scope="scope">
              <el-button-group>
                <el-button 
                  icon="el-icon-edit"
                  type="default" 
                  size="small"
                  @click="getCorporationDiscount(scope.row.id)">
                </el-button>
                <el-button 
                  icon="el-icon-delete"
                  type="default" 
                  size="small"
                  @click="deleteCorporationDiscount(scope.row.id)">
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

      </el-tab-pane>

      <!-- add one more for attributes -->
    </el-tabs>

    <el-dialog
      title="Markup Unit Cost"
      :visible.sync="markup_dialog"
      width="60%">

      <span>
        <el-row>
          <el-col :span="12">
            <el-select 
              v-model="unit_price_markup" 
              placeholder="Choose Markup" 
              filterable 
              clearable
              @change="calculateMarkup">
              <el-option
                v-for="item in markup_percentages"
                :key="item"
                :label="item + '%'"
                :value="item">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="12">
            <el-input v-model="tier.product_retail_price" disabled>
              <template slot="prepend">Unit Price</template>
            </el-input>
          </el-col>
        </el-row>
      </span>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="markup_dialog = false">Cancel</el-button>
        <el-button type="primary" @click="markup_dialog = false">Done</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Batch Markup Change"
      :visible.sync="batch_markup_dialog"
      width="30%">
      <span>
        <el-row>
          <el-col :span="12">
            <el-select 
            v-model="batch_unit_price_markup" 
            placeholder="Choose Markup" 
            filterable 
            clearable>
              <el-option
                v-for="item in markup_percentages"
                :key="item"
                :label="item + '%'"
                :value="item">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="batchMarkupUpdate()">Update</el-button>
        <el-button @click="batch_markup_dialog = false">Cancel</el-button>
      </span>
    </el-dialog>

    <pre v-if="config.debug">{{$data}}</pre>
  </div>
</template>

<style scoped>
  .categories-scroll-pane {
    height: 500px;
    overflow-y: scroll;
    padding: 20px;
    border: 1px solid #E4E7ED;
  }
  .checkbox-holder {
    margin:0 0 5px 0;
  }

  .checkbox-list {
    display:block;
    margin: 0 0 5px 0;
    padding: 0;
  }

  ul.sync-list {
    padding:0;
    margin:0;
    list-style: none;
  }

  ul.sync-list li {
    margin:10px 0 10px 0;
  }

  .template-thumb{
    width:50px;
    height:50px;
  }
</style>

<script>
  import Config from '@/store/Config.js';
  import Tables from '@/store/Tables.js';
  import lodash from 'lodash';   
  import CountryList from '@/components/utils/CountryList.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return {
        header_info: {},

        page_alias: 'Edit Product',
        page_slug: 'edit-product',

        config: Config.config,
        pricing_tiers_columns: Tables.pricing_tiers.columns,
        pricing_tiers_order_by: Tables.pricing_tiers.order_by,
        pricing_tiers_sort_by: Tables.pricing_tiers.sort_by,

        label_position: 'left',
        loading: true,
        jwt: '',

         quote: {
          selected_tier: {},
          quantity: 0,
          markup: 0,
          unit_price_selected: 1,
          cost_price: '',
          sell_price: '',
          gross_profit: ''
        },


        rules: {
          product: {
            name: [
              { required: true, message: 'Please enter a name', trigger: 'blur' }
            ],
            sku: [
              { required: true, message: 'Please enter a SKU', trigger: 'blur' }
            ],
            product_type_id: [
              { required: true, message: 'Please select a product type', trigger: 'blur' }
            ],
            short_description: [
              { required: true, message: 'Please enter a short description', trigger: 'blur' }
            ],
            tax_class_id: [
              { required: true, message: 'Please select a tax class', trigger: 'blur' }
            ],
            min_recommended_margin: [
              { required: true, message: 'Please enter a minimum recommended margin', trigger: 'blur' }
            ],
            max_recommended_margin: [
              { required: true, message: 'Please enter a maximum recommended margin', trigger: 'blur' }
            ]
          },

          tier: {
            country: [
              { required: true, message: 'Please select a country', trigger: 'blur' }
            ],  
            state: [
              { required: true, message: 'Please enter a state', trigger: 'blur' }
            ],  
            city: [
              { required: true, message: 'Please enter a city', trigger: 'blur' }
            ],                
            zip: [
              { required: true, message: 'Please enter a zip', trigger: 'blur' }
            ],  
            min_qty: [
              { required: true, message: 'Please enter a minimum quantity', trigger: 'blur' }
            ],  
            max_qty: [
              { required: true, message: 'Please enter a maximum quantity', trigger: 'blur' }
            ],  
            product_cost_price: [
              { required: true, message: 'Please enter a unit cost price', trigger: 'blur' }
            ],  
            product_retail_price: [
              { required: true, message: 'Please enter a unit retail price', trigger: 'blur' }
            ],  
            pack_cost_price: [
              { required: true, message: 'Please enter a pack cost price', trigger: 'blur' }
            ],  
            pack_retail_price: [
              { required: true, message: 'Please enter a pack retail price', trigger: 'blur' }
            ],  
            pack_max_quantity: [
              { required: true, message: 'Please enter the maximum quantity', trigger: 'blur' }
            ],  
            pack_weight: [
              { required: true, message: 'Please enter the pack weight', trigger: 'blur' }
            ],  
            pack_discount: [
              { required: false, message: 'Please enter a pack discount value', trigger: 'blur' }
            ],  
            product_turnaround_time: [
              { required: true, message: 'Please enter a aurnaround time', trigger: 'blur' }
            ],  
            supplier_id: [
              { required: true, message: 'Please select a supplier', trigger: 'change' }
            ],  
            print_type_id: [
              { required: true, message: 'Please select a print type', trigger: 'change' }
            ],  
            tax_class_id: [
              { required: true, message: 'Please select a shipping tax class', trigger: 'change' }
            ],  
          },

          option: {
            name: [
              { required: true, message: 'Please enter a name', trigger: 'blur' }
            ] 
          },
        },

        //Variable for Tab:
        active_tab: 'details',

        //Variables for Details Tab:
        product: {product_shipping_matrix: []},
        product_types: [],
        tax_classes: [],
        margin_range: [],

        //Variables for Pricing Tiers Tab:
        country_list: CountryList.countries,

        form_tier_show: false,
        form_tier_mode: 'Add',

        tier: {
          country: 'Ireland', 
          city: '*',
          state: '*'        
        },

        tiers: [],
        print_types: [],
        suppliers: [],
        shipping_tax_classes: [],

        markup_dialog: false,
        unit_price_markup: '',
        markup_percentages: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100],

        batch_markup_dialog: false,
        batch_unit_price_markup: '',

        tier_headings: {
          'ID': 'id',
          'Country': 'country',
          'State': 'state',
          'Zip':'zip',
          'City': 'city',
          'Minimum Quantity': 'min_qty',
          'Maximum Quantity': 'max_qty',
          'Product Cost Price': 'product_cost_price',
          'Product Retail Price': 'product_retail_price',
          'Product Turnaround Time': 'product_turnaround_time',
          'Pack Weight':'pack_weight',
          'Pack Discount': 'pack_discount',
          'Pack Max Quantity': 'pack_max_quantity',
          'Pack Cost Price': 'pack_cost_price',
          'Pack Retail Price': 'pack_retail_price',
          'Pack Width': 'pack_width',
          'Pack Height': 'pack_height',
          'Pack Depth': 'pack_depth',
          'Minimum Weight': 'min_weight',
          'Maximum Weight': 'max_weight',
          'Minimum Volume': 'min_volume',
          'Maximum Volume': 'max_volume',
          'Minimum Subtotal': 'min_subtotal',
          'Maximum Subtotal': 'max_subtotal',
          'Rate':'rate',
          'Supplier ID': 'supplier_id',
          'Supplier Name': 'supplier.name',
          'Product ID': 'product_id',
          'Print Type ID': 'print_type_id',
          'Price Modified Date': 'price_modified_date',
          'Tax Class': 'tax_class',
          'Created At': 'created_at',
          'Updated At': 'updated_at',
        },

        //Variables for Images Tab:
        form_image_show: false,
        form_image_mode: '',

        product_image: {
          name: '',
          description: '',
          sort_order: 0,
        },

        fileList: [],
        image: null,
        imageData: '',

        //Variables for Categories Tab:
        product_categories: [],
        selected_categories: [],
        filter_categories: '',

        //Variables for Corporations Tab:
        corporations: [],
        selected_corporations: [],
        filter_corporations: '',

        //Variables for Tags Tab:
        tags: [],
        selected_tags: [],
        filter_tags: '',

        //Variables for Related Products Tab:
        products: [],
        selected_products: [],
        filter_products: '',

        //Variables for Files Tab:
        form_file_show: false,
        form_file_mode: '',

        files: [],

        file: {
          product_id: '',
          description: '',
          available: '',
          container: '',
          updated_user_id: '',
          created_user_id: '',
        },

        upload_file: null,

        //Variables for Options Tab
        options: [],

        option: {
          name: '',       
        },

        form_option_show: false,
        form_option_mode: 'Add',

        //Variables for Corporation Discounts Tab
        corporation_discount: {},
        corporation_discounts: [],

        form_corporation_discount_show: false,
        form_corporation_discount_mode: 'Add',

        /*
        Variables for if a tab has already been loaded - Used to save 
        loading time and data instead of constantly reloading each tab:
        */

        details_tab_loaded: false,
        pricing_tiers_tab_loaded: false,
        images_tab_loaded: false,
        categories_tab_loaded: false,
        corporations_tab_loaded: false,
        tags_tab_loaded: false,
        related_products_tab_loaded: false,
        files_tab_loaded: false,
        options_tab_loaded: false,
        corporation_discounts_tab_loaded: false
      };
    },

    mounted: function() {
      const me = this;

      me.jwt = Utils.decodejwt();

      /* NEEDED FOR DETAILS TAB ON LOAD */
      me.getProduct();
      me.getProductTypes();
      me.getTaxClasses();
    },

    computed: {
      filteredCategories() {
        const me = this;
        return me.product_categories.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_categories.toLowerCase())>=0;});
      },

      filteredProducts() {
        const me = this;
        return me.products.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_products.toLowerCase())>=0;});
      },

      filteredTags() {
        const me = this;
        return me.tags.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_tags.toLowerCase())>=0;});
      },

      filteredCorporations() {
        const me = this;
        return me.corporations.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_corporations.toLowerCase())>=0;});
      },
      
      imageUploadEndpoint: function() {
        const me = this;
        me.image_upload_endpoint = me.config.api + 'product/' + me.$route.params.id + '/image';
        return me.config.api + 'product/' + me.$route.params.id + '/image';
      },
    },

    watch: {
      'tier.min_qty': function(val){
        const me = this;
        if (me.product.is_tiered === 1){
          this.tier.max_qty = val;
        }
      }
    },

    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },

      resetForm(form_name) {
        const me = this;
        this.$refs[form_name].resetFields();
      },

      handleTabClick: function() {
        const me = this;
        console.log('Handle Tab Click Function');

        if(me.active_tab == 'details') {
          if(!me.details_tab_loaded) {
            me.getProduct();
            me.getProductTypes();
            me.getTaxClasses();
            me.details_tab_loaded = true;
          }
        } else if(me.active_tab == 'pricing_tiers') {
          if(!me.pricing_tiers_tab_loaded) {
            me.getProduct();
            me.getShippingTaxClasses();
            me.getSuppliers();
            me.getPrintTypes();
            me.pricing_tiers_tab_loaded = true;
          }
        } else if(me.active_tab == 'categories') {
          if(!me.images_tab_loaded) {
            me.getProductCategories();
            me.getAssignedProductCategories();
            me.images_tab_loaded = true;
          }
        } else if(me.active_tab == 'corporations') {
          if(!me.corporations_tab_loaded) {
            me.getCorporations();
            me.getAssignedCorporations();
            me.corporations_tab_loaded = true;
          }
        } else if(me.active_tab == 'tags') {
          if(!me.tags_tab_loaded) {
            me.getProductTags();
            me.getAssignedProductTags();
            me.tags_tab_loaded = true;
          }
        } else if(me.active_tab == 'related-products') {
          if(!me.related_products_tab_loaded) {
            me.getProducts();
            me.getAssignedRelatedProducts();
            me.related_products_tab_loaded = true;
          }
        } else if(me.active_tab == 'files') {
          if(!me.files_tab_loaded) {
            me.getFiles();
            me.files_tab_loaded = true;
          }
        } else if(me.active_tab == 'options') {
          if(!me.options_tab_loaded) {
            me.getOptions();
            me.options_tab_loaded = true;
          } 
        } else if(me.active_tab == 'corporation_discounts') {
          if(!me.corporation_discounts_tab_loaded) {
            me.getCorporationDiscounts();
            me.getCorporations();
            me.corporation_discounts_tab_loaded = true;
          }
        }
      },

      /* METHODS FOR TOGGLING FORMS WITHIN TAB PANES */
      toggleFormTier: function(action) {
        console.log('Toggle Form Tier Function');
        const me = this;

        me.form_tier_show = !me.form_tier_show;
        me.form_tier_mode = action;    
      },

      toggleFormImage: function(action) {
        console.log('Toggle Form Image Function');
        const me = this;

        me.form_image_show = !me.form_image_show;
        me.form_image_mode = action;    
      },

      toggleFormFile: function(action) {
        console.log('Toggle Form File Function');
        const me = this;

        me.form_file_show = !me.form_file_show;
        me.form_file_mode = action;  
      },

      toggleFormOption: function(action) {
        console.log('Toggle Form Option Function');
        const me = this;

        me.form_option_show = !me.form_option_show;
        me.form_option_mode = action;    
      },

      toggleFormCorporationDiscount: function(action) {
        console.log('Toggle Form Corporation Discount Function');
        const me = this;

        me.form_corporation_discount_show = !me.form_corporation_discount_show;
        me.form_corporation_discount_mode = action;    
      },
      /* END METHODS FOR TOGGLING FORMS */

      /* METHODS FOR DETAILS TAB */
      getProduct: function() {
        console.log('Get Product Function');
        const me = this;

        me.loading = true;

        me.$http.get(me.config.api + 'product/{id}', {params: {admin: 1, id : me.$route.params.id}}).then(
          response => {
          console.log('Get Product Function - Success Getting Data')  

          me.product = response.body.data;

          me.margin_range[0] = me.product.min_recommended_margin;
          me.margin_range[1] = me.product.max_recommended_margin;

          me.loading = false;
        }, response => {
          console.log('Get Product Function - Error Getting Data');

          me.loading = false;
        });
      },

      updateProduct: function(form_name) {
        console.log('Update Product Function');
        const me = this;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.product.updated_user_id = me.jwt.sub;
            me.product.min_recommended_margin = me.margin_range[0];
            me.product.max_recommended_margin = me.margin_range[1];

            me.$http.put(me.config.api + 'product/{id}', me.product, {params: {id : me.$route.params.id}}).then(
              response => {
              console.log('Update Product Function - Success Putting Data')  

              me.getProduct();

              me.$notify({
                title: 'Success',
                message: 'The Product Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update Product Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      getProductTypes: function() {
        console.log('Get Product Types Function');
        const me = this;

        me.$http.get(me.config.api + 'product-type', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Product Types Function - Success Getting Data')  
       
          me.product_types = response.body.data;
        }, response => {
          console.log('Get Product Types Function - Error Getting Data');
        });
      },

      getTaxClasses: function() {
        console.log('Get Tax Classes Function');
        const me = this;

        me.$http.get(me.config.api + 'taxClasses', {params: {pagination: 1000}}).then(
        response => {
          console.log('Get Tax Classes Function - Success Getting Data')  

          me.tax_classes = response.body.data;
        }, response => {
          console.log('Get Tax Classes Function - Error Getting Data');
        });
      },    
      /* END DETAILS TAB */


      /* PRICING TIERS TAB */
      addPricingTier: function(form_name) {
        console.log('Add Pricing Tier Function');
        const me = this;

        me.tier.product_id = me.$route.params.id;

        me.$refs[form_name].validate((valid) => {
          if (valid) {
            me.$http.post(me.config.api + 'supplier/{id}/shipping-matrix', me.tier, {params: {id : me.tier.supplier_id}}).then(
              response => {
              console.log('Add Pricing Tier Function - Success Posting Data');

              me.getProduct();

              me.form_tier_show = false,
              me.form_tier_mode = 'Add',  
            
              me.resetForm('tier')                  
              
              me.$notify({
                title: 'Success',
                message: 'The Pricing Tier Was Added',
                type: 'success'
              });
            }, response => {
              console.log('Add Pricing Tier Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      deletePricingTier: function(tier_id) {
        console.log('Delete Pricing Tier Function');
        const me = this;

        me.$confirm('This will permanently delete the tier - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.loading = true;
          me.$http.delete(me.config.api + 'shipping-matrix/{id}', {params: {id: tier_id}}).then(
            response => {
              console.log('Delete Pricing Tier Function - Success Deleting Data')  
 
              me.getProduct();

              me.$notify({
                title: 'Success',
                message: 'The Pricing Tier Was Deleted',
                type: 'success'
              });

              me.loading = false;
            }, response => {
              console.log('Delete Pricing Tier Function - Error Deleting Data');

              me.loading = false;
          });
        }).catch(() => {
          me.$message({
            type: 'info',
            message: 'Delete Canceled'
          });     
          me.loading = false;     
        });
      },

      getPricingTier: function(matrix_pricing_tier_id, matrix_supplier_id) {
        console.log('Get Pricing Tier Function');
        const me = this;

        me.$http.get(me.config.api + 'supplier/{supplier_id}/shipping-matrix/{matrix_id}', {params: {supplier_id: matrix_supplier_id, matrix_id: matrix_pricing_tier_id}}).then(
          response => {
          console.log('Get Pricing Tier Function - Success Getting Data')  

          me.toggleFormTier('Update');

          me.tier = response.body.data;
        }, response => {
          console.log('Get Pricing Tier Function - Error Getting Data');
        });
      },

      updatePricingTier: function(form_name) {
        console.log('Update Pricing Tier Function');
        const me = this;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.$http.put(me.config.api + 'supplier/{supplier_id}/shipping-matrix/{matrix_id}', me.tier, {params: {supplier_id: me.tier.supplier_id, matrix_id: me.tier.id}}).then(
              response => {
              console.log('Update Pricing Tier Function - Success Putting Data');

              me.getProduct();

              me.$notify({
                title: 'Success',
                message: 'The Tier Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update Pricing Tier Function - Error Putting Fata');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      getShippingTaxClasses: function() {
        console.log('Get Shipping Tax Classes Function');
        const me = this;

        me.$http.get(me.config.api + 'taxClasses', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Shipping Tax Classes Function - Success Getting Data')  

          me.shipping_tax_classes = response.body.data;
        }, response => {
          console.log('Get Shipping Tax Classes Function - Error Getting Data');
        });
      },

      getSuppliers: function() {
        console.log('Get Suppliers Function');
        const me = this;

        me.$http.get(me.config.api + 'supplier', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Suppliers Function - Success Getting Data')  

          me.suppliers = response.body.data;
        }, response => {
          console.log('Get Suppliers Function - Error Getting Data');
        });
      },

      getPrintTypes: function() {
        console.log('Get Print Types Function');
        const me = this;

        me.$http.get(me.config.api + 'printType', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Print Types Function - Success Getting Data')  

          me.print_types = response.body.data;
        }, response => {
          console.log('Get Print Types Function - Error Getting Data');
        });
      },

      calculateMarkup: function() {
        const me = this;
        var percentage = 1 + (me.unit_price_markup / 100);
        var cost = me.tier.product_cost_price;
        var markup = (cost * percentage).toFixed(2);
        me.tier.product_retail_price = markup;
      },

      batchMarkupUpdate: function() {
        console.log('Batch Markup Update Function');
        const me = this;

        me.$confirm('This will change all of the retail prices - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.$http.put(me.config.api + 'batch-update-markup/{id}', me.batch_unit_price_markup, {params: {id: me.$route.params.id}}).then(
            response => {
            console.log('Batch Markup Update Function - Success Putting Data')  

            me.getProduct();
            me.batch_markup_dialog = false;
            me.batch_unit_price_markup = '';

            me.$notify({
              title: 'Success',
              message: 'The Markup Was Updated',
              type: 'success'
            });
          }, response => {
            console.log('Batch Markup Update Function - Error Putting Data');
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete Canceled'
          });          
        });
      },

      clearTier: function() {
        console.log('Clear Tier Function');
        const me = this;

        me.tier = {
          country: 'Ireland', 
          state: '*'        
        };
      },
      /* END PRICING TIERS TAB */

      /* IMAGES TAB */
      submitUpload: function () {
        console.log('Submit Upload Function');
        const me = this;

        me.$refs.upload.submit();
      },

      uploadSuccess: function() {
        const me = this;
        console.log('Upload Success Function');
        
        me.form_image_show = false,
        me.form_image_mode = '',  
        me.resetForm('product_image');
        me.getProduct();
        me.$notify({
          title: 'Success',
          message: 'Image Added',
          type: 'success'
        }); 
      },
      
      deleteImage: function(id) {
        console.log('Delete Image Function');
        const me = this;

        me.$confirm('This will permanently delete the image - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.loading = true;
          me.$http.delete(me.config.api + 'product/{product_id}/image/{image_id}', {params: {product_id: me.$route.params.id, image_id: id}}).then(
            response => {
              console.log('Delete Image Function - Success Deleting Data')  

              me.getProduct();
              
              me.$notify({
                title: 'Success',
                message: 'The Image Was Deleted',
                type: 'success'
              });

              me.loading = false;
            }, response => {
              console.log('Delete Image Function - Error Deleting Data');

              me.loading = false;
          });
        }).catch(() => {
          me.$message({
            type: 'info',
            message: 'Delete Canceled'
          });    
          me.loading = false;      
        });
      },

      getImage: function(id) {
        console.log('Get Image Function');
        const me = this;

        me.$http.get(me.config.api + "productImage/{id}", {params: {id: id}}).then(
          response => {
          console.log('Get Image Function - Success Getting Data')  

          me.product_image = response.body.data;

          me.toggleFormImage('Update');
        }, response => {
          console.log('Get Image Function - Error Getting Data');
        });
      },

      handleRemove(file, fileList) {
        console.log(file, fileList);
      },

      handlePreview(file) {
        console.log(file);
      },

      handleExceed(files, fileList) {
        this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
      },

      beforeRemove(file, fileList) {
        return this.$confirm(`Remove ${ file.name }？`);
      },
      /* END IMAGES TAB */

      /* CATEGORIES TAB */
      getProductCategories: function() {
        console.log('Get Product Categories Function');
        const me = this;

        me.$http.get(me.config.api + 'productCategory', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Product Categories Function - Success Getting Data')  
  
          me.product_categories = response.body.data;
        }, response => {
          console.log('Get Product Categories Function - Error Getting Data');
        });
      },

      getAssignedProductCategories: function() {
        console.log('Get Assigned Product Categories Function');
        const me = this;

        me.$http.get(me.config.api + 'product/{id}/category', {params: {id: me.$route.params.id, pagination: 1000}}).then(
          response => {
          console.log('Get Assigned Product Categories Function - Success Getting Data')  

          me.selected_categories = response.body.data.map(a => a.id);
        }, response => {
          console.log('Error Getting Data');
        });
      },

      assignProductCategories: function() {
        const me = this;
        console.log('Assign Product Categories Function');

        me.$http.post(me.config.api + 'product/{id}/category', me.selected_categories, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Assign Product Categories Function - Success Posting Data');  

          me.getAssignedProductCategories();
          me.filter_categories = '';

          me.$notify({
            title: 'Success',
            message: 'This Categories Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('Assign Product Categories Function - Error Posting Data');
        });
      },
      /* END CATEGORIES TAB */

      /* CORPORATIONS TAB */
      getAssignedCorporations: function() {
        console.log('Get Assigned Corporations Function');
        const me = this;

        me.$http.get(me.config.api + "product/{id}/corporation", {params: {id: me.$route.params.id, pagination: 1000}}).then(
          response => {
          console.log('Get Assigned Corporations Function - Success Getting Data')  

          me.selected_corporations = response.body.data.map(a => a.id);
        }, response => {
          console.log('Get Assigned Corporations Function - Error Getting Data');
        });
      },

      getCorporations: function(goToPage) {
        console.log('Get Corporations Function');
        const me = this;

        me.$http.get(me.config.api + 'corporation', {params: {backend_call: 1, pagination: 1000}}).then(
          response => {
          console.log('Get Corporations Function - Success Getting Data')  
          
          me.corporations = response.body.data;
        }, response => {
            console.log('Get Corporations Function - Error Getting Data');

            me.$notify({
              title: 'Error',
              message: response.statusText,
              type: 'error'
            });
        });
      },

      assignCorporations: function() {
        const me = this;
        console.log('Assign Corporations Function');

        me.$http.post(me.config.api + 'product/{id}/corporation', me.selected_corporations, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Assign Corporations Function - Success Posting Data');  

          me.getAssignedCorporations();
          me.filter_corporations = '';
          
          me.$notify({
            title: 'Success',
            message: 'This Corporations Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('Assign Corporations Function - Error Posting Data');
        });
      },
      /* END CORPORATIONS TAB */

      /* TAGS TAB */
      getProductTags: function() {
        console.log('Get Product Tags Function');
        const me = this;

        me.loading = true;

        me.$http.get(me.config.api + 'productTag', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Product Tags Function - Success Getting Data')  

          me.tags = response.body.data;

          me.loading = false;
        }, response => {
          console.log('Get Product Tags Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      getAssignedProductTags: function() {
        console.log('Get Assigned Product Tags Function');
        const me = this;

        me.$http.get(me.config.api + 'product/{id}/productTag', {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Get Assigned Product Tags Function - Success Getting Data')  

          me.selected_tags = response.body.data.map(a => a.id);
        }, response => {
          console.log('Get Assigned Product Tags Function - Error Getting Data');
        });
      },

      assignTags: function() {
        const me = this;
        console.log('Asssign Tags Function');

        me.$http.post(me.config.api + 'product/{id}/productTag', me.selected_tags, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Asssign Tags Function - Success Posting Data');  

          me.getAssignedProductTags();
          me.filter_tags = '';

          me.$notify({
            title: 'Success',
            message: 'This Tags Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('Asssign Tags Function - Error Posting Data');
        });
      },
      /* END TAGS TAB */

      /* RELATED PRODUCTS TAB */
      getProducts: function() {
        console.log('Get Products Function');
        const me = this;

        me.$http.get(me.config.api + 'product', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Products Function - Success Getting Data')  

          me.products = response.body.data;
        }, response => {
          console.log('Get Products Function - Error Getting Data');
        });
      },

      getAssignedRelatedProducts: function() {
        console.log('Get Assigned Related Products Function');
        const me = this;

        me.$http.get(me.config.api + 'product/{id}/relatedProducts', {params: {id: me.$route.params.id, pagination: 1000}}).then(
          response => {
          console.log('Get Assigned Related Products Function - Success Getting Data')  

          me.selected_products = response.body.data.map(a => a.id);
        }, response => {
          console.log('Get Assigned Related Products Function - Error Getting Data');
        });
      },

      assignProductRelatedProducts: function() {
        const me = this;
        console.log('Assign Related Products Function');

        me.$http.post(me.config.api + 'product/{id}/relatedProducts', me.selected_products, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Assign Related Products Function - Success Posting Data');  

          me.getAssignedRelatedProducts();
          me.filter_products = '';

          me.$notify({
            title: 'Success',
            message: 'This Products Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('Assign Related Products Function - Error Posting Data');
        });
      },
      /* END RELATED PRODUCTS TAB */

      /* FILES TAB */
      getFiles: function() {
        console.log('Get Files Function');
        const me = this;

        me.$http.get(me.config.api + "product/{id}/files", {params: {id: me.$route.params.id, pagination: 1000}}).then(
          response => {
          console.log('Get Files Function - Success Getting Data')  

          me.files = response.body.data;
        }, response => {
          console.log('Get Files Function - Error Getting Data');
        });
      },

      addFile: function(form_name) {
        console.log('Add File Function');
        const me = this;

        me.file.updated_user_id = me.jwt.sub;
        me.file.created_user_id = me.jwt.sub;
        me.file.product_id = me.$route.params.id;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.$http.post(me.config.api + 'files', me.file).then(
              response => {
              console.log('Add File Function - Success Posting Data')  

              me.getFiles();

              me.form_file_show = false;
              me.form_file_mode = 'Add';  

              me.file = {
                product_id: '',
                description: '',
                available: '',
                container: '',
                updated_user_id: '',
                created_user_id: '',
              };
            
              me.resetForm('file');            
              
              me.$notify({
                title: 'Success',
                message: 'The File Was Added',
                type: 'success'
              });
            }, response => {
              console.log('Add File Function - Error Posting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      deleteFile: function(id) {
        console.log('Delete File Function');
        const me = this;

        me.$confirm('This will permanently delete the file - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.loading = true;

          me.$http.delete(me.config.api + 'files/{id}', {params: {id: id}}).then(
            response => {
            console.log('Delete File Function - Success Deleting Data')  

            me.getFiles();
            me.loading = false;
            me.$notify({
              title: 'Success',
              message: 'The File Was Deleted',
              type: 'success'
            });
          }, response => {
            console.log('Delete File Function - Error Deleting Data');

            me.loading = false;
          });
        }).catch(() => {
          me.$message({
            type: 'info',
            message: 'Delete Canceled'
          });     

          me.loading = false;     
        });
      },

      getFile: function(id) {
        console.log('Get File Function');
        const me = this;

        me.$http.get(me.config.api + 'files/{id}', {params: {id: id}}).then(
          response => {
          console.log('Get File Function - Success Getting Data')  

          me.toggleFormFile('Update')
          
          me.file = response.body.data;
        }, response => {
          console.log('Get File Function - Error Getting Data');
        });
      },

      updateFile: function(form_name) {
        console.log('Update File Function');
        const me = this;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.file.updated_user_id = me.jwt.sub;

            me.$http.put(me.config.api + 'files/{id}', me.file, {params: {id: me.file.id}}).then(
              response => {
              console.log('Update File Function - Success Putting Data')  

              me.getFiles();

              me.$notify({
                title: 'Success',
                message: 'The File Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update File Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      onFileChange: function(e) {
        console.log('On File Change Function');
        const me = this;

        let upload_file = event.target;
				if(upload_file.files && upload_file.files[0]) {
          me.file.container = upload_file.files[0];
        }
      },

      clearFile: function() {
        console.log('Clear File Function');
        const me = this;

        me.file = {
          product_id: '',
          description: '',
          available: '',
          container: '',
          updated_user_id: '',
          created_user_id: '',
        };
      },
      /* END FILES TAB */

      /* OPTIONS TAB */
      clearOption: function() {
        console.log('Clear Option Function');
        const me = this;

        me.option = {
          name: '',       
        };
      },

      getOptions: function() {
        console.log('Get Options Function');
        const me = this;

        me.$http.get(me.config.api + 'product/{id}/product-options', {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Get Options Function - Success Getting Data')  

          me.options = response.body.data;
        }, response => {
          console.log('Get Options Function - Error Getting Data');
        });
      },

      addOption: function(form_name) {
        console.log('Add Option Function');
        const me = this;

        me.option.product_id = me.$route.params.id;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.$http.post(me.config.api + 'product-options', me.option).then(
              response => {
              console.log('Add Option Function - Success Posting Fata')  

              me.getOptions();

              me.form_option_show = false;
              me.form_option_mode = 'Add';  
            
              me.resetForm('option');            
              
              me.$notify({
                title: 'Success',
                message: 'The Option Was Added',
                type: 'success'
              });
            }, response => {
              console.log('Add Option Function - Error Posting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      deleteOption: function(id) {
        console.log('Delete Option Function');
        const me = this;

        me.$confirm('This will permanently delete the option - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.loading = true;
          me.$http.delete(me.config.api + 'product-options/{id}', {params: {id : id}}).then(
            response => {
              console.log('Delete Option Function - Success Deleting Data')  

              me.getOptions();
              
              me.$notify({
                title: 'Success',
                message: 'The Option Was Deleted',
                type: 'success'
              });

              me.loading = false;
            }, response => {
              console.log('error deleting data');
              me.loading = false;
          });
        }).catch(() => {
          me.$message({
            type: 'info',
            message: 'Delete Canceled'
          });     
          me.loading = false;     
        });
      },

      getOption: function(id) {
        console.log('Get Option Function');
        const me = this;
        me.$http.get(me.config.api + 'product-options/{id}', {params: {id : id}}).then(
          response => {
          console.log('Get Option Function - Success Getting Data')  

          me.toggleFormOption('Update');

          me.option = response.body.data;
        }, response => {
          console.log('Get Option Function - Error Getting Data');
        });
      },

      updateOption: function(form_name) {
        console.log('Update Option Function');
        const me = this;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.$http.put(me.config.api + 'product-options/{id}', me.option, {params: {id: me.option.id}}).then(
              response => {
              console.log('Update Option Function - Success Putting Data')  

              me.getOptions();

              me.$notify({
                title: 'Success',
                message: 'The Option Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update Option Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },
      /* END OPTIONS TAB */

      /* DISCOUNTS TAB */
      getCorporationDiscounts: function() {
        console.log('Get Corporation Discounts Function');
        const me = this;

        me.$http.get(me.config.api + 'product/{id}/corpDiscount', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Get Corporation Discounts Function - Success Getting Data')  

          me.corporation_discounts = response.body.data;
        }, response => {
          console.log('Get Corporation Discounts Function - Error Getting Data');
        });
      },

      addCorporationDiscount: function(form_name) {
        console.log('Add Corporation Discount Function');
        const me = this;

        //me.corporation_discount.product_id = me.$route.params.id;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.$http.post(me.config.api + 'product/{id}/corpDiscount', me.corporation_discount, {params: {id: me.$route.params.id}}).then(
              response => {
              console.log('Add Corporation Discount - Success Posting Data');

              me.getCorporationDiscounts();

              me.form_corporation_discount_show = false,
              me.form_corporation_discount_mode = 'Add',  
            
              me.resetForm(form_name);                  
              
              me.$notify({
                title: 'Success',
                message: 'The Corporation Discount Was Added',
                type: 'success'
              });
            }, response => {
              console.log('Add Corporation Discount Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      getCorporationDiscount: function(id) {
        console.log('Get Corporation Discount Function');
        const me = this;

        me.$http.get(me.config.api + 'corp-discount/{id}', {params: {id: id}}).then(
          response => {
          console.log('Get Corporation Discount Function - Success Getting Data')  

          me.toggleFormCorporationDiscount('Update');

          me.corporation_discount = response.body.data;
        }, response => {
          console.log('Get Corporation Discount Function - Error Getting Data');
        });
      },

      deleteCorporationDiscount: function(id) {
        console.log('Delete Corporation Discount Function');
        const me = this;

        me.$confirm('This will permanently delete the Corporation Discount - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.loading = true;
          me.$http.delete(me.config.api + 'corp-discount/{id}', {params: {id: id}}).then(
            response => {
              console.log('Delete Corporation Discount Function - Success Deleting Data')  

              me.getCorporationDiscounts();
              
              me.$notify({
                title: 'Success',
                message: 'The Corporation Discount Was Deleted',
                type: 'success'
              });

              me.loading = false;
            }, response => {
              console.log('Delete Corporation Discount Function - Error Deleting Data');
              me.loading = false;
          });
        }).catch(() => {
          me.$message({
            type: 'info',
            message: 'Delete Canceled'
          });     
          me.loading = false;     
        });
      },

      updateCorporationDiscount: function(form_name) {
        console.log('Update Corporation Discount Function');
        const me = this;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.$http.put(me.config.api + 'corp-discount/{id}', me.corporation_discount, {params: {id: me.corporation_discount.id}}).then(
              response => {
              console.log('Update Corporation Discount Function - Success Putting Data');

              me.getCorporationDiscounts();

              me.$notify({
                title: 'Success',
                message: 'The Corporation Discount Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update Corporation Discount Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },
      /* END DISCOUNTS TAB */
    },

    filters: {
      prettyIndexName(text) {
        var prettyName = text.replace(/_/g, ' ').toUpperCase();
        return prettyName
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/products/ProductEdit.vue